export enum ECourseStatus {
	GROUNDED = "Grounded",
	FLYING = "Flying",
	REMOVE = "Remove",
}
